import { getHotelImages } from '@/services/request';

// Фото для галереи в карточке запрашиваются пачкой: выдача поиска их не
// содержит, а карточек на экране сразу десяток. Коды копятся один тик,
// уходят одним запросом и остаются в памяти до перезагрузки страницы.
const MAX_CODES = 30;
const BATCH_DELAY = 100;

const cache = {};
const waiting = new Map();
let timer = null;

const flush = () => {
	timer = null;

	const codes = [...waiting.keys()].slice(0, MAX_CODES);
	if (!codes.length) return;

	const resolvers = codes.map(code => {
		const resolve = waiting.get(code);
		waiting.delete(code);
		return {code, resolve};
	});

	getHotelImages(codes)
		.then(res => {
			const images = res.data || {};
			resolvers.forEach(({code, resolve}) => {
				cache[code] = images[code] || [];
				resolve(cache[code]);
			});
		})
		// Галерея — украшение: не показываем ошибку, остаёмся с одной картинкой.
		.catch(() => resolvers.forEach(({code, resolve}) => resolve(cache[code] || [])));

	if (waiting.size) timer = setTimeout(flush, BATCH_DELAY);
};

export const hotelImages = (code) => {
	if (cache[code]) return Promise.resolve(cache[code]);

	return new Promise(resolve => {
		const pending = waiting.get(code);

		waiting.set(code, images => {
			if (pending) pending(images);
			resolve(images);
		});

		if (!timer) timer = setTimeout(flush, BATCH_DELAY);
	});
};
